// 雲印表機列印中間層對外入口
// 後端 API 完成後，呼叫端把 buildOrderDetailPrintRequest() 的結果丟給 api.service 即可。
import {
  buildOrderDetailEscPosBytes,
  buildOrderDetailDirectPrintData,
  renderOrderDetailText,
  sampleOrderDetailPrintData,
} from './orderDetailEscPosBuilder'
import { bytesToBase64 } from './escPosEncoder'

// 內層 print_data 字串：{ printer_serial, direct_print_data }
// 注意：不含 legacy order_detail，避免重複列印。
export function buildOrderDetailPrintData(data, printerSerial) {
  return JSON.stringify({
    printer_serial: printerSerial,
    direct_print_data: buildOrderDetailDirectPrintData(data),
  })
}

// 送後端的完整 request：{ magic, print_data }
export function buildOrderDetailPrintRequest(data, { printerSerial, magic }) {
  return {
    magic,
    print_data: buildOrderDetailPrintData(data, printerSerial),
  }
}

// 新需求：分離的頂層列印欄位
// data 為 OrderDetailPrintData；回傳 { print_data, printer_serial }
// 後端兩者同時存在才會列印；序號缺一律不送，避免誤印。
export function buildPrintFields(data, printerSerial) {
  if (!printerSerial) return {}
  return {
    print_data: buildOrderDetailDirectPrintData(data),
    printer_serial: printerSerial,
  }
}

export {
  buildOrderDetailEscPosBytes,
  buildOrderDetailDirectPrintData,
  renderOrderDetailText,
  sampleOrderDetailPrintData,
  bytesToBase64,
}
